import { Component, ViewChild, DoCheck, OnInit } from '@angular/core';
import { Configuration } from '../../configuration';
import { Helpers } from '../../helpers';
import { SelectableItem } from '../../models/common/selectableItem';
import { BlockUI } from 'ng-block-ui';
import { DateRangeModel } from '../../models/common/date.range';
import { IPage } from '../../models/common/paging';
import { BookmarkedTenderSummaryDto } from '../../models/tenders/tender.models';
import { NoticeStatus, NoticeEnumsToSelectList } from '../../models/notices/notice.enums';
import { SearchBookmarkedContractAwardsDto } from '../../models/contract.awards/contract.award.models';
import { BookmarkedContractAwardSummaryDto } from '../../models/contract.awards/contract.award.models';
import { ContractAwardService } from '../../services/contract.award.service';
import { LoggedInUserService } from '../../auth/logged.in.user';
import { CmsDialogService } from '../../services/cms.dialog.service';
import { CmsDialogDto } from '../../models/cms.dialogs/cms.dialogs.models';

@Component({
    selector: 'contractAwards/bookmarked',
    template: require('./bookmarked.component.html'),
    styles: [require('../filter.toggle.shared.css')]
})
export class CaBookmarkedComponent implements OnInit, DoCheck {
    request: SearchBookmarkedContractAwardsDto;
    private previousRequest: SearchBookmarkedContractAwardsDto;

    publishedDate: DateRangeModel;
    statuses: Array<SelectableItem<NoticeStatus>>;
    options: Array<SelectableItem<string>>;

    results: IPage<BookmarkedContractAwardSummaryDto>;
    resultOptions;

    @BlockUI('ca-results-block') private resultsBlock;
    @ViewChild('deleteModal', { static: false }) private deleteModal: any;
    @ViewChild('resultsPage', { static: false }) private resultsView;
    loading: boolean = false;

    subscribed: boolean;
    dialogName: string;
    dialogHeader: string;
    dialogBody: string;

    constructor(private readonly contractAwardService: ContractAwardService, private readonly helpers: Helpers, configuration: Configuration,
        loggedInUserService: LoggedInUserService,
        private readonly cmsDialogService: CmsDialogService) {
        this.request = new SearchBookmarkedContractAwardsDto(configuration);
        this.previousRequest = this.helpers.clone(this.request);

        this.publishedDate = new DateRangeModel();

        this.resultOptions = {
            availableButtons: ['removeResult', 'print']
        };

        this.statuses = NoticeEnumsToSelectList.getStatuses();

        var user = loggedInUserService.getCurrentUser();
        this.subscribed = !user.canAdHoc('notSubscribed');

        this.options = [
            { text: 'Most Recent', value: 'PublishedDate' },
            { text: 'Start Date', value: 'StartDate' },
            { text: 'End Date', value: 'EndDate' },
            { text: 'Type', value: 'Type' },
            { text: 'Title', value: 'Title' }
        ];

        if (!this.request.sortProperty) {
            this.request.sortProperty = 'PublishedDate';
        }
    }

    ngOnInit() {

        if (this.subscribed) {
            this.dialogName = 'Bookmarked Awards Info - Subscribed';
        }
        else {
            this.dialogName = 'Bookmarked Awards Info - Not Subscribed';
        }

        this.cmsDialogService.getByDescription(this.dialogName).subscribe((result: CmsDialogDto) => {
            this.dialogHeader = result.header;
            this.dialogBody = result.body;
        });

        this.search();
    }

    ngOnDestroy() {
        $('#bookmarked-awards-info-modal').modal('hide');
        $('#delete-modal').modal('hide');
    }

    ngDoCheck() {
        if (!this.request.equals(this.previousRequest)) {
            this.search();
        }
    }

    search() {
        this.loading = true;
        this.resultsBlock.start();
        const publishedDateDto = this.publishedDate.convertDatesToDto();

        this.request.publishedDateFrom = publishedDateDto.startDate;
        this.request.publishedDateTo = publishedDateDto.endDate;

        if (this.previousRequest.pageNumber === this.request.pageNumber) {
            //We changed something other than the page number, so reset the search to page 1
            this.request.pageNumber = 0;
        }

        this.previousRequest = this.helpers.clone(this.request);

        this.contractAwardService.getBookmarked(this.request).subscribe((results: IPage<BookmarkedContractAwardSummaryDto>) => {
            this.results = results;

            if (this.resultsView) {
                this.resultsView.onSearchComplete();
            }

            this.resultsBlock.stop();
            this.loading = false;
        }, () => {
            this.resultsBlock.stop();
            this.loading = false;
        });
    }

    removeBookmark(award: BookmarkedTenderSummaryDto) {
        this.deleteModal.showAndPopulate(award, award.title);
    }

    confirmRemove(award: BookmarkedTenderSummaryDto) {
        this.deleteModal.clearAndHide();
        this.contractAwardService.removeBookmark(award.bookmarkId).subscribe(() => {
            this.search();
        });
    }

    showInfoDialog() {
        $('#bookmarked-awards-info-modal').modal();
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/contract.awards/bookmarked.component.ts